import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import userResources from "api/userResources";
import getSelectClassNames from "components/SelectFieldClasses/SelectFieldClasses";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { IoMdPrint } from "react-icons/io";
import Select from "react-tailwindcss-select";
import { toast } from "react-toastify";
import { logo3 } from "utils/images";
import { logo2 } from "utils/images";
import { logo1 } from "utils/images";
import { FaFileExcel } from "react-icons/fa";
import ScrollToTopOnRouteChange from "components/ScrollToTopOnRouteChange/ScrollToTopOnRouteChange";

export default function CustomComponent({
  airlineSales,
  employeeSales,
  supplierSales,
  destinationSales,
}) {
  // Form handling using react-hook-form
  const {
    register,
    handleSubmit,
    clearErrors,
    formState: { errors },
    watch,
    setValue,
    reset,
  } = useForm();

  // State variables

  const [searchValue, setSeachvalue] = useState();
  const [isLoading, setIsLoading] = React.useState(false);
  const [isError, setIsError] = React.useState(false);
  const [data, setData] = React.useState([]);
  const [selectedFrom, setSelectedFrom] = useState();
  const [selectedTo, setSelectedTo] = useState();
  const [paymentMethodData, setPaymentMethodData] = useState([]);
  const [paymentMethodId, setPaymentMethodId] = useState();
  // Pagination state: pageIndex (0-based), pageSize, and totalRows from response
  const [pagination, setPagination] = React.useState({
    pageIndex: 0,
    pageSize: 10,
    totalRows: 0,
  });

  const start_date = watch("start_date");
  const end_date = watch("end_date");
  const airLine_id = watch("airLine_id");
  const sales_agent_id = watch("sales_agent_id");
  const supplier_id = watch("supplier_id");
  const travel_from = watch("from");
  const travel_to = watch("to");

  const getTransactionType = async () => {
    try {
      const response = await userResources.transactionType();
      const combinedData = response.data.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      setPaymentMethodData(combinedData);
    } catch (error) {
      console.log(error);
    }
  };

  const getInvoiceList = async () => {
    setIsLoading(true);
    setIsError(false);

    try {
      // Include the page number in the params (pagination.pageIndex is 0-based)
      const params = {
        start_date,
        end_date,
        airLine_id,
        sales_agent_id,
        supplier_id,
        travel_from,
        travel_to,
        // travel_from: 26219,
        airticket_include: true,
        limit: pagination.pageSize,
        page: pagination.pageIndex + 1,
        supplier_transation_type_id: paymentMethodId,
        // pax_transation_type_id: 4,
      };
      const response = await userResources.agencySalesInvoiceList(params);

      // Update data from API
      setData(response?.data?.data || []);
      // Update pagination state from API's paginate_data
      if (response?.data?.paginate_data) {
        const paginate = response.data.paginate_data;
        setPagination((prev) => ({
          ...prev,
          pageIndex: paginate.current_page - 1,
          pageSize: paginate.per_page,
          totalRows: paginate.total,
          lastPage: paginate.last_page,
          nextPageUrl: paginate.next_page_url,
          prevPageUrl: paginate.prev_page_url,
        }));
      }
    } catch (error) {
      console.error("Error fetching invoice list:", error);
      setIsError(true);
      setData([]);
      toast.error("Error fetching invoice list");
    } finally {
      setIsLoading(false);
    }
  };

  const onSubmit = () => {
    // Reset to first page on new search
    setPagination((prev) => ({ ...prev, pageIndex: 0 }));
    getInvoiceList();
  };

  // Handle page change
  const handlePageChange = (newPageIndex) => {
    setPagination((prev) => ({ ...prev, pageIndex: newPageIndex }));
  };

  // When the pagination.pageIndex changes, fetch new data
  useEffect(() => {
    // Only trigger if form has been submitted (or if you want to load on mount)
    if (start_date || end_date || airLine_id || sales_agent_id || supplier_id) {
      getInvoiceList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.pageIndex, pagination.pageSize]);

  // Calculate totals using reduce
  const totalAmountSum = data.reduce(
    (acc, invoice) => acc + (Number(invoice.totalAmount) || 0),
    0
  );
  const totalCommissionSum = data.reduce(
    (acc, invoice) => acc + (Number(invoice.totalCommission) || 0),
    0
  );

  // Function to handle print
  const handlePrint = () => {
    const printWindow = window.open("", "_blank");
    const printContent = document.querySelector(".printable").innerHTML;

    // Current date for the report
    const currentDate = new Date().toLocaleDateString();

    // Determine report title and details based on your conditions
    let report = "";
    if (supplierSales?.supplierTrue) {
      report =
        supplierSales?.supplierData?.find((s) => s.value == supplier_id)
          ?.label || "";
    } else if (employeeSales?.employeetrue) {
      report =
        employeeSales?.employeeData?.find((s) => s.value == sales_agent_id)
          ?.label || "";
    } else if (airlineSales?.airline) {
      report =
        airlineSales?.airlineData?.find((s) => s.value == airLine_id)?.label ||
        "";
    }

    let title = "Agency Sales";
    if (supplierSales?.supplierTrue) {
      title = "Suppliers Sales";
    } else if (employeeSales?.employeetrue) {
      title = "Employees Sales";
    } else if (airlineSales?.airline) {
      title = "Airlines Sales";
    }

    // Dynamic content based on destination sales
    let dynamicContent = "";
    if (destinationSales?.destination) {
      dynamicContent = `
      <div style="font-size: 16px; margin-top: 4px;">
        <div>From: ${selectedFrom?.label || "-"}</div>
        <div>To: ${selectedTo?.label || "-"}</div>
      </div>
    `;
    } else {
      dynamicContent = `
      <div style="font-size: 16px; margin-top: 4px;">
        ${report}
      </div>
    `;
    }

    // Title positioning
    const titleLeft = !destinationSales?.destination
      ? `<div style="font-size: 22px; font-weight: bold;">${title}</div>`
      : "";

    const titleRight = destinationSales?.destination
      ? `<div style="font-size: 22px; font-weight: bold;">${title}</div>`
      : "";

    // Print header with logos and summary
    const printHeader = `
    <div class="print-header" style="display: flex; justify-content: space-between; align-items: end; padding: 20px; border-bottom: 2px solid #000; font-family: Arial, sans-serif; background: black; color: white;">
      <!-- Left Section -->
      <div style="flex: 1;">
        ${titleLeft}
        ${dynamicContent}
        <div style="font-size: 14px; margin-top: 8px;">Generated on: ${currentDate}</div>
      </div>

      <!-- Center Section (Logos) -->
      <div style="flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center;">
        <img src="${logo1}" alt="Logo 1" style="height: 45px; margin-bottom: 6px;" />
        <img src="${logo2}" alt="Logo 2" style="height: 13px; margin-bottom: 4px;" />
        <img src="${logo3}" alt="Logo 3" style="height: 13px;" />
      </div>

      <!-- Right Section (Financial Summary) -->
      <div style="flex: 1; text-align: right;">
        ${titleRight}
        <div style="font-size: 16px;">Total Amount: <strong>${totalAmountSum.toFixed(
          2
        )}</strong></div>
        <div style="font-size: 16px;">Total Commission: <strong>${totalCommissionSum.toFixed(
          2
        )}</strong></div>
        <div style="font-size: 16px;">Start Date: <strong>${start_date}</strong></div>
        <div style="font-size: 16px;">End Date: <strong>${end_date}</strong></div>
      </div>
    </div>
  `;

    // Print styles with page numbering support
    const printStyles = `
    <style>
      body { 
        font-family: Arial, sans-serif; 
        margin: 0.5cm 0.5cm 1.5cm 0.5cm; /* Extra bottom margin for page number */ 
        color: #000; 
        background: #fff; 
        position: relative;
      }
      .print-header { 
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px; 
        padding: 20px;
        background-color: #000 !important;
        color: #fff !important;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }
      table { 
        width: 100%; 
        border-collapse: collapse; 
        margin-top: 10px;
        font-size: 12px;
      }
      th, td { 
        border: 1px solid #000; 
        padding: 5px; 
        text-align: left;
      }
      th { 
        background-color: #f2f2f2 !important; 
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }
      @page {
        size: auto;
        margin: 0.5cm 0.5cm 1.5cm 0.5cm;
      }
      @media print {
        .page-number {
          position: fixed;
          bottom: 0;
          right: 0;
          font-size: 10px;
          padding: 5px 10px;
        }
              .no-print {
      display: none !important;
    }
        .page-number:after {
          content: "Page " counter(page);
        }
        .page-break {
          page-break-after: always;
        }
      }
    </style>
  `;

    // Create the print document with page numbering
    printWindow.document.write(`
    <html>
      <head>
        <title>${title} Report</title>
        ${printStyles}
      </head>
      <body>
        ${printHeader}
        ${printContent}
        <script>
          // Add page numbers after content loads
          window.onload = function() {
            // Calculate total pages (fallback for browsers that don't support CSS counters)
            const pageCount = Math.ceil(document.body.scrollHeight / (window.innerHeight - 100));
            document.querySelectorAll('.page-number').forEach(el => {
              el.textContent = \`Page \${window.pageCounter || 1} of \${pageCount}\`;
            });
            
            setTimeout(function() {
              window.print();
              window.close();
            }, 200);
          }
        </script>
      </body>
    </html>
  `);
    printWindow.document.close();
  };

  // ————— NEW: Export to Excel —————
  const handleExportExcel = () => {
    let report = "";
    if (supplierSales?.supplierTrue) {
      report =
        supplierSales.supplierData.find((s) => s.value == supplier_id)?.label ||
        "";
    } else if (employeeSales?.employeetrue) {
      report =
        employeeSales.employeeData.find((e) => e.value == sales_agent_id)
          ?.label || "";
    } else if (airlineSales?.airline) {
      report =
        airlineSales.airlineData.find((a) => a.value == airLine_id)?.label ||
        "";
    }

    let title = "Agency Sales";
    if (supplierSales?.supplierTrue) title = "Suppliers Sales";
    else if (employeeSales?.employeetrue) title = "Employees Sales";
    else if (airlineSales?.airline) title = "Airlines Sales";

    const headerRows = [
      [title.toUpperCase()],
      destinationSales?.destination
        ? [`From: ${travel_from || "-"}`, `To: ${travel_to || "-"}`]
        : [report],
      [`Start Date: ${start_date}`, `End Date: ${end_date}`],
      [`Generated on: ${new Date().toLocaleDateString()}`],
      [],
    ];

    const columns = [
      "Invoice #",
      "Date",
      "Customer",
      "Supplier",
      "Sales Agent",
      "Pax Payment Method",
      "Supplier Payment Method",
      "Total Amount",
      "Total Commission",
    ];

    const dataRows = data.map((inv) => [
      inv.invoice_number || "-",
      inv.created_at ? inv.created_at.split("T")[0] : "-",
      inv.customer?.full_name || "-",
      inv.supplier?.name || "-",
      inv.sales_agents?.name || "-",
      paymentMethodData.find(
        (pm) => pm.value == inv.airticketFromPaxPaymentMethodId
      )?.label || "N/A",
      paymentMethodData.find(
        (pm) => pm.value == inv.airticketFromSupplierPaymentMethodId
      )?.label || "N/A",
      Number(inv.totalAmount) || 0,
      Number(inv.totalCommission) || 0,
    ]);

    const totalsRow = [
      "TOTAL",
      "",
      "",
      "",
      "",
      "",
      "",
      totalAmountSum,
      totalCommissionSum,
    ];

    const sheetData = [...headerRows, columns, ...dataRows, [], totalsRow];

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(sheetData);

    // Merge title row across all columns
    ws["!merges"] = [
      {
        s: { r: 0, c: 0 },
        e: { r: 0, c: columns.length - 1 },
      },
    ];

    // Column widths
    ws["!cols"] = columns.map(() => ({ wch: 20 }));

    // Title styling
    const titleCell = ws["A1"];
    if (titleCell) {
      titleCell.s = {
        font: { bold: true, sz: 20, color: { rgb: "FF1F497D" } },
        alignment: { horizontal: "center", vertical: "center" },
        fill: { fgColor: { rgb: "FFEAF1FB" } },
        border: {
          bottom: { style: "thick", color: { rgb: "FF1F497D" } },
        },
      };
    }

    const headerRowIndex = headerRows.length;

    // Column header styling
    for (let c = 0; c < columns.length; c++) {
      const addr = XLSX.utils.encode_cell({ r: headerRowIndex, c });
      const cell = ws[addr];
      if (!cell) continue;
      cell.s = {
        font: { bold: true, color: { rgb: "FFFFFFFF" } },
        fill: { fgColor: { rgb: "FF2F5D9E" } },
        alignment: { horizontal: "center" },
        border: {
          bottom: { style: "thin", color: { rgb: "FF000000" } },
        },
      };
    }

    // Zebra stripe data rows
    const dataStart = headerRowIndex + 1;
    const dataEnd = dataStart + dataRows.length - 1;
    for (let r = dataStart; r <= dataEnd; r++) {
      const isEven = (r - dataStart) % 2 === 0;
      for (let c = 0; c < columns.length; c++) {
        const addr = XLSX.utils.encode_cell({ r, c });
        const cell = ws[addr];
        if (!cell) continue;
        cell.s = {
          fill: { fgColor: { rgb: isEven ? "FFFFFFFF" : "FFF9F9F9" } },
        };
      }
    }

    // Format numbers
    [7, 8].forEach((colIdx) => {
      for (let r = dataStart; r <= dataEnd; r++) {
        const addr = XLSX.utils.encode_cell({ r, c: colIdx });
        const cell = ws[addr];
        if (!cell) continue;
        cell.t = "n";
        cell.z = "#,##0.00";
      }
    });

    // Totals row style
    const totalsRowIndex = dataEnd + 2;
    for (let c = 0; c < columns.length; c++) {
      const addr = XLSX.utils.encode_cell({ r: totalsRowIndex, c });
      const cell = ws[addr];
      if (!cell) continue;
      cell.s = {
        font: { bold: true },
        fill: { fgColor: { rgb: "FFDFF0D8" } },
        border: {
          top: { style: "medium", color: { rgb: "FF000000" } },
        },
      };
    }

    // Freeze pane
    ws["!freeze"] = { xSplit: 0, ySplit: headerRowIndex + 1 };

    // Autofilter
    ws["!autofilter"] = {
      ref: XLSX.utils.encode_range({
        s: { r: headerRowIndex, c: 0 },
        e: { r: dataEnd, c: columns.length - 1 },
      }),
    };

    // Final download
    XLSX.utils.book_append_sheet(wb, ws, "Report");
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(
      new Blob([wbout], { type: "application/octet-stream" }),
      `${title.replace(/\s+/g, "_")}_Report_${new Date()
        .toISOString()
        .slice(0, 10)}.xlsx`
    );
  };

  // Build the options array conditionally
  const combinedOptions = [];

  if (airlineSales?.airline) {
    combinedOptions.push({
      label: "Airlines",
      options: airlineSales?.airlineData || [],
    });
  }

  if (employeeSales?.employeetrue) {
    combinedOptions.push({
      label: "Employees",
      options: employeeSales?.employeeData || [],
    });
  }
  if (supplierSales?.supplierTrue) {
    combinedOptions.push({
      label: "Supplier",
      options: supplierSales?.supplierData || [],
    });
  }

  const dynamicFieldName = airlineSales?.airline
    ? "airLine_id"
    : employeeSales?.employeetrue
    ? "sales_agent_id"
    : supplierSales?.supplierTrue
    ? "supplier_id"
    : "";

  // Determine if pagination buttons should be disabled
  const disablePrev = pagination.pageIndex === 0;
  const disableNext = pagination.lastPage
    ? pagination.pageIndex + 1 >= pagination.lastPage
    : true;

  useEffect(() => {
    getTransactionType();
  }, []);

  useEffect(() => {
    airlineSales?.getairLinesValue(searchValue);
  }, [searchValue]);

  return (
    <section>
      <ScrollToTopOnRouteChange />
      <div className="bg-gray-900 p-4 text-white sm:mt-4">
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="grid gap-6 pb-4 sm:pb-0"
        >
          {/* Input Fields */}
          <div
            className={`grid grid-cols-1 items-end gap-4 ${
              destinationSales?.destination
                ? "sm:grid-cols-5"
                : airlineSales?.airline ||
                  employeeSales?.employeetrue ||
                  supplierSales?.supplierTrue
                ? "sm:grid-cols-4"
                : "sm:grid-cols-3"
            }
`}
          >
            <div>
              <label
                htmlFor="start_date"
                className="mb-2 block text-sm font-medium text-white"
              >
                Start Date
              </label>
              <input
                type="date"
                id="start_date"
                placeholder="Enter Start Date"
                className="w-full rounded border border-gray-300 bg-white p-2 text-gray-800"
                {...register("start_date", {
                  required: "Start Date is required",
                })}
              />
              {errors.start_date && (
                <span className="text-xs text-red-500">
                  {errors.start_date.message}
                </span>
              )}
            </div>
            <div>
              <label
                htmlFor="end_date"
                className="mb-2 block text-sm font-medium text-white"
              >
                End Date
              </label>
              <input
                type="date"
                id="end_date"
                placeholder="Enter End Date"
                className="w-full rounded border border-gray-300 bg-white p-2 text-gray-800"
                {...register("end_date", { required: "End Date is required" })}
              />
              {errors.end_date && (
                <span className="text-xs text-red-500">
                  {errors.end_date.message}
                </span>
              )}
            </div>

            {(airlineSales || employeeSales || supplierSales) && (
              <div>
                <label
                  htmlFor="entity_id"
                  className="mb-2 block text-sm font-medium text-white"
                >
                  {airlineSales?.airline && !employeeSales?.employeetrue
                    ? "Airline"
                    : !airlineSales?.airline && employeeSales?.employeetrue
                    ? "Employee"
                    : supplierSales?.supplierTrue
                    ? "Supplier"
                    : ""}
                </label>

                <Select
                  {...register(dynamicFieldName, {
                    required: "Selection is required.",
                  })}
                  value={combinedOptions
                    .flatMap((group) => group.options)
                    .find((option) => option.value === watch(dynamicFieldName))}
                  onChange={(selectedOption) => {
                    setValue(dynamicFieldName, selectedOption?.value || "");
                    clearErrors(dynamicFieldName);
                  }}
                  onSearchInputChange={(e) => {
                    setSeachvalue(e.target.value);
                  }}
                  isDisabled={false}
                  options={combinedOptions}
                  isSearchable={true}
                  placeholder="Select..."
                  classNames={getSelectClassNames({
                    isDisabled: false,
                    selectProps: {},
                    isSelected: false,
                    value: watch(dynamicFieldName),
                  })}
                  formatOptionLabel={(data) => (
                    <li
                      className={`mb-1 block cursor-pointer select-none truncate rounded px-2 py-2 transition duration-200 ${
                        !data.isSelected
                          ? "bg-gray-200 text-gray-900"
                          : "bg-blue-800 text-gray-200"
                      }`}
                    >
                      {data.label}
                    </li>
                  )}
                />
                {errors?.[dynamicFieldName] && (
                  <span className="text-xs text-red-500">
                    {errors[dynamicFieldName]?.message}
                  </span>
                )}
              </div>
            )}

            {supplierSales?.supplierTrue && (
              <div>
                <label className="my-2 block text-sm font-medium">
                  Supplier Transaction Type
                </label>
                <Select
                  value={paymentMethodData.find(
                    (option) => option.value === paymentMethodId
                  )}
                  isDisabled={false}
                  onChange={(selectedOption) => {
                    setPaymentMethodId(selectedOption?.value || null);
                  }}
                  options={paymentMethodData}
                  isSearchable={true}
                  placeholder="Select Transaction Type"
                  classNames={getSelectClassNames({
                    isDisabled: false,
                    selectProps: {}, // optional if you’re not using form
                    isSelected: false,
                    value: paymentMethodId,
                  })}
                  formatOptionLabel={(data) => (
                    <li
                      className={`mb-1 block cursor-pointer select-none truncate rounded px-2 py-2 transition duration-200 ${
                        !data.isSelected
                          ? `bg-gray-200 text-gray-900`
                          : `bg-blue-800 text-gray-200`
                      }`}
                    >
                      {data.label}
                    </li>
                  )}
                />
              </div>
            )}

            {destinationSales?.destination ? (
              <div>
                <label className="mb-2 block text-sm font-medium text-white">
                  Destination From
                </label>
                <Select
                  {...register("from", {
                    required: "Destination from is required.",
                  })}
                  onSearchInputChange={(e) =>
                    destinationSales.setFromSearchValue(e.target.value)
                  }
                  value={selectedFrom}
                  onChange={(selectedOption) => {
                    setSelectedFrom(selectedOption);
                    setValue("from", selectedOption.value);
                    clearErrors("from");
                  }}
                  isDisabled={false}
                  options={destinationSales.fromData}
                  isSearchable={true}
                  placeholder="Select..."
                  classNames={getSelectClassNames({
                    isDisabled: false,
                    selectProps: {},
                    isSelected: false,
                    value: watch("from"),
                  })}
                  formatOptionLabel={(data) => (
                    <li
                      className={`mb-1 block cursor-pointer select-none truncate rounded px-2 py-2 transition duration-200 ${
                        !data.isSelected
                          ? "bg-gray-200 text-gray-900"
                          : "bg-blue-800 text-gray-200"
                      }`}
                    >
                      {data.label}
                    </li>
                  )}
                />
                {errors?.from && (
                  <span className="text-xs text-red-500">
                    {errors?.from?.message}
                  </span>
                )}
              </div>
            ) : null}

            {destinationSales?.destination ? (
              <div>
                <label className="mb-2 block text-sm font-medium text-white">
                  Destination To
                </label>
                <Select
                  {...register("to", {
                    required: "Destination to is required.",
                  })}
                  onSearchInputChange={(e) =>
                    destinationSales.setToSearchValue(e.target.value)
                  }
                  value={selectedTo}
                  onChange={(selectedOption) => {
                    setSelectedTo(selectedOption);
                    setValue("to", selectedOption.value);
                    clearErrors("to");
                  }}
                  isDisabled={false}
                  options={destinationSales.toData}
                  isSearchable={true}
                  placeholder="Select..."
                  classNames={getSelectClassNames({
                    isDisabled: false,
                    selectProps: {},
                    isSelected: false,
                    value: watch("to"),
                  })}
                  formatOptionLabel={(data) => (
                    <li
                      className={`mb-1 block cursor-pointer select-none truncate rounded px-2 py-2 transition duration-200 ${
                        !data.isSelected
                          ? "bg-gray-200 text-gray-900"
                          : "bg-blue-800 text-gray-200"
                      }`}
                    >
                      {data.label}
                    </li>
                  )}
                />
                {errors?.to && (
                  <span className="text-xs text-red-500">
                    {errors?.to?.message}
                  </span>
                )}
              </div>
            ) : null}

            <div
              className={`flex flex-col gap-2 ${
                supplierSales?.supplierTrue ? "col-span-4" : ""
              }`}
            >
              {(start_date || end_date) && (
                <button
                  type="button"
                  className="w-full rounded bg-red-500 px-4 py-1 text-white hover:bg-red-600"
                  onClick={() => {
                    setValue("start_date", null);
                    setValue("end_date", null);
                    setSelectedFrom(null);
                    setSelectedTo(null);
                    setData([]);
                    setPaymentMethodId(null);
                    reset();
                  }}
                >
                  Cancel
                </button>
              )}
              <button
                type="submit"
                className="w-full rounded bg-blue-500 px-4 py-2 text-white hover:bg-blue-600"
              >
                Search Invoice
              </button>
            </div>
          </div>
        </form>
      </div>
      {/* Print Button */}
      {!isLoading && !isError && data.length > 0 && (
        <div className="flex justify-between pt-2">
          <FaFileExcel
            onClick={handleExportExcel}
            size={25}
            className="ml-4 cursor-pointer text-green-600"
          />
          <IoMdPrint
            onClick={handlePrint}
            size={25}
            className="cursor-pointer text-gray-900 dark:text-white"
          />
        </div>
      )}
      {/* Display Loading, Error or Data */}
      <div className="relative">
        {isLoading && (
          <p className="flex items-center justify-center p-4 transition-all duration-500 ease-in-out">
            <span className="loading-xl loading loading-spinner text-green-500"></span>
          </p>
        )}
      </div>
      {data.length <= 0 && !isLoading && (
        <div className="flex min-h-screen items-center justify-center">
          <p className="p-4">
            Oops! No data found. Please adjust your filters or try refreshing
            the page.
          </p>
        </div>
      )}

      {!isLoading && !isError && data.length > 0 && (
        <>
          <div className="printable  overflow-x-auto py-2">
            <table className="min-w-full divide-y divide-gray-200 overflow-scroll">
              <thead className="bg-gray-800">
                <tr>
                  <th className="px-2 py-4 text-left text-xs font-medium uppercase tracking-wider text-white">
                    Invoice Number
                  </th>
                  <th className="px-2 py-4 text-left text-xs font-medium uppercase tracking-wider text-white">
                    Created At
                  </th>
                  <th className="px-2 py-4 text-left text-xs font-medium uppercase tracking-wider text-white">
                    Customer Name
                  </th>
                  <th className="px-2 py-4 text-left text-xs font-medium uppercase tracking-wider text-white">
                    Supplier Name
                  </th>
                  <th className="px-2 py-4 text-left text-xs font-medium uppercase tracking-wider text-white">
                    Sales Agent Name
                  </th>
                  <th className="px-2 py-4 text-left text-xs font-medium uppercase tracking-wider text-white">
                    Pax payment method
                  </th>
                  <th className="px-2 py-4 text-left text-xs font-medium uppercase tracking-wider text-white">
                    Supplier payment method
                  </th>
                  <th className="px-2 py-4 text-left text-xs font-medium uppercase tracking-wider text-white">
                    Total Amount
                  </th>
                  <th className="px-2 py-4 text-left text-xs font-medium uppercase tracking-wider text-white">
                    Total Commission
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-600 bg-gray-700">
                {data.map((invoice, index) => (
                  <tr key={index}>
                    <td className="px-2 py-3 text-sm text-white">
                      {invoice.invoice_number || "-"}
                    </td>
                    <td className="px-2 py-3 text-sm text-white">
                      {invoice.created_at
                        ? invoice.created_at.split("T")[0]
                        : "-"}
                    </td>
                    <td className="px-2 py-3 text-sm text-white">
                      {invoice.customer?.full_name || "-"}
                    </td>
                    <td className="px-2 py-3 text-sm text-white">
                      {invoice.supplier?.name || "-"}
                    </td>
                    <td className="px-2 py-3 text-sm text-white">
                      {invoice.sales_agents?.name || "-"}
                    </td>
                    <td className="px-2 py-3 text-sm font-bold text-white">
                      {paymentMethodData.find(
                        (item) =>
                          item.value == invoice?.airticketFromPaxPaymentMethodId
                      )?.label || "N/A"}
                    </td>
                    <td className="px-2 py-3 text-sm font-bold text-white">
                      {paymentMethodData.find(
                        (item) =>
                          item.value ==
                          invoice?.airticketFromSupplierPaymentMethodId
                      )?.label || "N/A"}
                    </td>
                    <td className="px-2 py-3 text-sm text-white">
                      {invoice.totalAmount || "-"}
                    </td>
                    <td className="px-2 py-3 text-sm text-white">
                      {invoice.totalCommission || "-"}
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot className="no-print bg-gray-800">
                <tr>
                  <td
                    className="px-2 py-3 text-sm font-bold text-white"
                    colSpan="7"
                  >
                    Totals
                  </td>
                  <td className="px-2 py-3 text-sm font-bold text-white">
                    {totalAmountSum.toFixed(2)}
                  </td>
                  <td className="px-2 py-3 text-sm font-bold text-white">
                    {totalCommissionSum.toFixed(2)}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
          {/* Pagination Controls */}
          <div className="flex items-center justify-between">
            {/* Select field to choose the per-page limit */}
            <div className="flex items-center space-x-2">
              <label htmlFor="pageSize" className="text-black">
                Per Page:
              </label>
              <select
                id="pageSize"
                value={pagination.pageSize}
                onChange={(e) =>
                  setPagination((prev) => ({
                    ...prev,
                    pageSize: Number(e.target.value),
                    pageIndex: 0, // reset page index when page size changes
                  }))
                }
                className="rounded border border-gray-300 bg-white p-1 text-gray-800"
              >
                <option value="10">10</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="500">500</option>
                <option value="1000">1000</option>
              </select>
            </div>
            <div className="flex items-center justify-center space-x-4 py-4">
              <button
                onClick={() => handlePageChange(pagination.pageIndex - 1)}
                disabled={disablePrev}
                className={`rounded px-4 py-2 ${
                  disablePrev
                    ? "cursor-not-allowed bg-gray-400"
                    : "bg-blue-500 hover:bg-blue-600"
                } text-white`}
              >
                Previous
              </button>
              <span>
                Page {pagination.pageIndex + 1}{" "}
                {pagination.lastPage && `of ${pagination.lastPage}`}
              </span>
              <button
                onClick={() => handlePageChange(pagination.pageIndex + 1)}
                disabled={disableNext}
                className={`rounded px-4 py-2 ${
                  disableNext
                    ? "cursor-not-allowed bg-gray-400"
                    : "bg-blue-500 hover:bg-blue-600"
                } text-white`}
              >
                Next
              </button>
            </div>
          </div>
        </>
      )}
    </section>
  );
}
